var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 60,
    viewBox: "0 0 88 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 59,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 59,
    rx: 15.5,
    stroke: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5074_36279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7729 18.012C48.7219 17.955 46.8844 18.0345 45.2854 19.77C43.6864 21.504 43.9324 23.493 43.9684 23.544C44.0044 23.595 46.2484 23.6745 47.6809 21.657C49.1134 19.6395 48.8239 18.0705 48.7729 18.012ZM53.7439 35.6115C53.6719 35.4675 50.2564 33.7605 50.5744 30.4785C50.8924 27.195 53.0869 26.295 53.1214 26.1975C53.1559 26.1 52.2259 25.0125 51.2404 24.462C50.5168 24.0739 49.716 23.8515 48.8959 23.811C48.7339 23.8065 48.1714 23.6685 47.0149 23.985C46.2529 24.1935 44.5354 24.8685 44.0629 24.8955C43.5889 24.9225 42.1789 24.1125 40.6624 23.898C39.6919 23.7105 38.6629 24.0945 37.9264 24.39C37.1914 24.684 35.7934 25.521 34.8154 27.7455C33.8374 29.9685 34.3489 33.4905 34.7149 34.5855C35.0809 35.679 35.6524 37.4715 36.6244 38.7795C37.4884 40.2555 38.6344 41.28 39.1129 41.628C39.5914 41.976 40.9414 42.207 41.8774 41.7285C42.6304 41.2665 43.9894 41.001 44.5264 41.0205C45.0619 41.04 46.1179 41.2515 47.1994 41.829C48.0559 42.1245 48.8659 42.0015 49.6774 41.6715C50.4889 41.34 51.6634 40.083 53.0344 37.5345C53.5549 36.3495 53.7919 35.709 53.7439 35.6115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7729 18.012C48.7219 17.955 46.8844 18.0345 45.2854 19.77C43.6864 21.504 43.9324 23.493 43.9684 23.544C44.0044 23.595 46.2484 23.6745 47.6809 21.657C49.1134 19.6395 48.8239 18.0705 48.7729 18.012ZM53.7439 35.6115C53.6719 35.4675 50.2564 33.7605 50.5744 30.4785C50.8924 27.195 53.0869 26.295 53.1214 26.1975C53.1559 26.1 52.2259 25.0125 51.2404 24.462C50.5168 24.0739 49.716 23.8515 48.8959 23.811C48.7339 23.8065 48.1714 23.6685 47.0149 23.985C46.2529 24.1935 44.5354 24.8685 44.0629 24.8955C43.5889 24.9225 42.1789 24.1125 40.6624 23.898C39.6919 23.7105 38.6629 24.0945 37.9264 24.39C37.1914 24.684 35.7934 25.521 34.8154 27.7455C33.8374 29.9685 34.3489 33.4905 34.7149 34.5855C35.0809 35.679 35.6524 37.4715 36.6244 38.7795C37.4884 40.2555 38.6344 41.28 39.1129 41.628C39.5914 41.976 40.9414 42.207 41.8774 41.7285C42.6304 41.2665 43.9894 41.001 44.5264 41.0205C45.0619 41.04 46.1179 41.2515 47.1994 41.829C48.0559 42.1245 48.8659 42.0015 49.6774 41.6715C50.4889 41.34 51.6634 40.083 53.0344 37.5345C53.5549 36.3495 53.7919 35.709 53.7439 35.6115Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5074_36279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(32 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIc);
export default __webpack_public_path__ + "static/media/apple_ic.c75ff30d4ed64da2f690988594de7b0c.svg";
export { ForwardRef as ReactComponent };